import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LangObj } from 'src/app/models';
import { LanguageService } from 'src/app/services';

@Component({
  selector: 'app-open-page-layout',
  templateUrl: './open-page-layout.component.html',
  styleUrls: ['./open-page-layout.component.css']
})
export class OpenPageLayoutComponent implements OnInit {

  language: string;
  languages: LangObj[];
  subscriptions: Subscription = new Subscription();

  constructor(
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {

    //
    this.language = this.languageService.getLanguage();
    this.languages = this.languageService.languagesObj;
    
    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
        this.languages = this.languageService.languagesObj;
      })
    );
  }


  /**
   * 
   * @param value
   */
  selectLanguage(value: string): void {

    this.languageService.selectLanguage(value);
  }

}
